<template>
  <v-card :loading="loading" class="pa-3" v-if="workSample" flat :color="$vuetify.theme.dark ? '#2d2d2d' : '#f9fafb'"  height="100%">
    <v-row v-if="workSample && workSample.student ">
      <v-col cols="12" lg="1" md="1" sm="0" xs="0"></v-col>
      <v-col cols="12" lg="10" md="10" sm="12" xs="12">
        <v-card class="rounded-a-lg my-5 " >
          <v-row class="pa-5">
            <v-col cols="12">
              <v-row dir="auto">
                <v-col cols="12" lg="6" md="6" sm="12">
                  <v-card flat>
                    <h3 class="text-title font-weight-bold">{{ workSample.title }}</h3>
                    <p dir="auto">{{ workSample.caseDescription }}</p>
                  </v-card>
                </v-col>
                <v-col cols="12" lg="6" md="6" sm="12" dir="auto">
                  <div class="d-flex flex-wrap justify-center">
                    <v-card
                      class="info text-center d-flex flex-column align-center justify-center ma-1"
                      width="150"
                      min-width="150"
                      flat
                      style="height: 80px"
                      :title="workSample.createdDate | moment('YYYY-MM-DD - h:mm A')"
                    >
                      {{ $t("portfolio.general.createdDate") }}
                      <h5 class="font-weight-light font-weight-bold">
                        {{
                          new Date(workSample.createdDate).toLocaleDateString($i18n.locale, {
                            year: "numeric",
                            month: "long",
                            day: "numeric"
                          })
                        }}
                      </h5>
                    </v-card>
                    <v-card v-if="workSample.modifiedDate"
                      class="info text-center d-flex flex-column align-center justify-center  ma-1"
                      width="150"
                      flat
                      min-width="150"
                      style="height: 80px"
                      :title="workSample.modifiedDate | moment('YYYY-MM-DD - h:mm A')"
                    >
                      {{ $t("portfolio.general.modifiedDate") }}
                      <h5 class="font-weight-light font-weight-bold">
                        {{
                          workSample.modifiedDate &&
                          new Date(workSample.modifiedDate).getFullYear() > 1
                            ? new Date(workSample.modifiedDate).toLocaleDateString($i18n.locale, {
                                year: "numeric",
                                month: "long",
                                day: "numeric"
                              })
                            : "-"
                        }}
                      </h5>
                    </v-card>
                    <v-card
                      class="info text-center d-flex flex-column align-center justify-center  ma-1"
                      width="150"
                      min-width="150"
                      flat
                      style="height: 80px"
                    >
                      {{ $t("studentName") }}
                      <h5 class="font-weight-light font-weight-bold">
                        {{ workSample.student.studentFullName }}
                      </h5>
                    </v-card>
                  </div>
                </v-col>

                <v-row class="ma-0 pa-0" style="gap: 1rem;">
                  <v-col cols="12">
                    <TagsMini
                      @delete="deleteTag"
                      v-model="workSample.tags"
                      :sourceGuid="workSampleId"
                      sourceType="WorkSample"
                      :showAdd="this.isInRole(0)"
                      :isRemovable="this.isInRole(0)"
                    />
                  </v-col>
                </v-row>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="my-6">
          <v-tabs v-model="activeTab" background-color="transparent">
            <v-tab v-for="tab in tabs" :key="tab.name" :value="tab.name">
              {{ $t(tab.name) }}{{ tab.hash==='attachments'&& workSample.files.length>0  ? ` (${workSample.files.length})` : '' }}
            </v-tab>
          </v-tabs>
          <v-divider ></v-divider>
      
            <component
            style="min-height: 40rem;"
            sourceType="0"
            :ownerGuid="workSample.student.studentGuid"
            :sourceGuid="workSample.workSampleGuid"
            :workSampleGuid="workSample.workSampleGuid"
            :description="workSample.description"
            v-model="workSample.files"
            :allowEdit="isInRole(0)"
            v-if="currentComponent"
            :is="currentComponent"
          ></component>
        </v-card>
      </v-col>
      <v-col cols="12" lg="1" md="1" sm="0" xs="0"> </v-col>
    </v-row>
        <no-data v-else></no-data>

    <AddWorkSample ref="editWorkSample" @success="getWorkSample()" />

    <v-fab-transition
      v-if="this.workSample && this.workSample.student&& this.workSample.student.studentGuid === this.$store.state.userData.guid && (currentComponent == 'Description' || currentComponent == 'Attachments')"
    >
      <v-btn
        :title="$t('edit')"
        color="secondary"
        fab
        large
        elevation="6"
        fixed
        bottom
        :left="$vuetify.rtl"
        :right="!$vuetify.rtl"
        class="v-btn--example"
        :class="$store.state.drawerMessage ? 'ml-16' : ''"
        :style="!$vuetify.rtl ? 'right:50px' : ''"
        @click="$refs.editWorkSample.showDialogEdit(workSample)"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </v-fab-transition>
  </v-card>
</template>

<script>
import TagsMini from "../../../../components/portfolio/tagsMini.vue";
import AddWorkSample from "../../../../components/portfolio/workSample/worksampleDialog.vue";
import Reflections from "../reflection/index.vue";
import Comments from "../comments/index.vue";
import Feedback from "../feedback/index.vue";
import Attachments from "../attachment/index.vue";
import Description from "./description.vue";
import NoData from "../../../../components/noData.vue";

export default {
  name: "ViewWorksSample",
  props: {},
  components: {
    TagsMini,
    Description,
    AddWorkSample,
    Reflections,
    Feedback,
    Comments,
    Attachments,
    NoData
  },
  data() {
    return {
      activeTab: "portfolio.description", // <-- make it a string, matching the route
      tabs: [
        { name: "portfolio.WorkSample.pages.description", hash: "description" },
        { name: "portfolio.WorkSample.pages.attachments", hash: "attachments" },
        { name: "portfolio.WorkSample.pages.reflections", hash: "reflections" },
        { name: "portfolio.WorkSample.pages.feedbacks", hash: "feedback" },
        { name: "portfolio.WorkSample.pages.comments", hash: "comments" }
      ],
      workSample: {},
      loading: true,
      error: null
    };
  },

  created() {
    this.getWorkSample();

    const { tab } = this.$route.query;
    if (tab) {
      const index = this.tabs.findIndex(t => t.hash === tab);
      if (index !== -1) {
        this.activeTab = index;
      }
    }
  },
  methods: {
    deleteTag(index) {
      this.workSample.tags.splice(index, 1);
    },
    openAddTags() {
      this.$refs.tagItemDialog.showDialog();
    },
    getWorkSample() {
      this.axios
        .get("WorkSample/Get/" + this.workSampleId)
        .then(res => {
          this.workSample = res.data.data;
          this.loading = false;
        })
        .catch(error => {
          this.error = error;
          this.loading = false;
        });
    }
  },
  watch: {
    activeTab(newVal) {
      const currentTab = this.$route.query.tab;
      const newTab = this.tabs[newVal].hash;
      if (currentTab !== newTab) {
        this.$router.replace({ query: { tab: newTab } });
      }
    }
  },

  computed: {
    currentComponent() {
      const map = {
        0: "Description",
        1: "Attachments",
        2: "Reflections",
        3: "Feedback",
        4: "Comments"
      };
      return map[this.activeTab] || null;
    },
    workSampleId() {
      return this.$route.params.id;
    }
  }
};
</script>
